export default __webpack_public_path__ + "static/media/socialimpact6.63d8acdb.jpeg";